import React, { useEffect, useState, useRef } from "react";
import "../css/printpage.css";
import { Button } from "antd";
import alphaLogo from "../images/alphaprint.jpg";
import ReactToPrint from "react-to-print";
import moment from "moment";
const Passprint = (props) => {
   
    useEffect(() => {console.log('props',props)
    
    ;}, []);
    const componentRef = useRef();
    let  proname ='';
    return (
      <div>
        <ReactToPrint
          trigger={() => (
            <button className="successButton" id="getPrintButton">
              Print
            </button>
          )}
          content={() => componentRef.current}
        />
        <div id="completePrint" ref={componentRef}>
        <table width="100%" className="borderTop borderLeft borderBottom borderRight">
            <tr className="borderBottom">
            <th><img src={alphaLogo} width="60px" height="60px"></img> &nbsp;{props.data.print[0].heading}</th>
            <th align="right"><div>{props.data.print[0].first_line}</div><div>{props.data.print[0].second_line}</div><div>{props.data.print[0].pincode}</div><div>Mobile-{props.data.print[0].mobile}</div></th>
            </tr>
            </table>
            <table width="100%" className="borderLeft borderRight">
            <tr><th>&nbsp;</th><th>&nbsp;</th></tr>
            <tr><th colspan="2" align="center" style={{fontSize:"20px"}}><b><u>Receipt/Bill</u></b></th></tr>
            <tr><th>&nbsp;</th><th>&nbsp;</th></tr>
            <tr>
              <th align="left" style={{fontSize:"15px"}}> To : <b>{props.data.gender == 'Male' ? 'Mr.' : 'Mrs.'}{props.data.patient}{`(${props.data.patientid})`}</b></th>
              <th align="right"><div>Bill : {props.data.code}</div><div>Date : {props.data.date.split('-').reverse().join('-')}</div></th>
            </tr>
            <tr><th>&nbsp;</th><th>&nbsp;</th></tr>
          </table>
          <table width="100%" className="borderLeft borderRight">
              <tr className="borderBottom">
                <th>S.no</th>
                <th>Particulars</th>
                <th>Charges</th>
              </tr>
              {props.data.product.map((list,index)=>
              <tr>
              <td align="center" style={{padding:'1%'}}>{index+1}</td>
              <td align="center">{list.proname}</td>
              <td align="center">{Number(list.productrate).toFixed(2)}</td>
            </tr>           
              )}
            <tr className="borderTop">
            <th>&nbsp;</th>
            <th align="right">Charges&nbsp;Rs</th>
            <th align="center">{(Number(props.data.amount) + Number(props.data.discount)).toFixed(2)}</th>
          </tr>
          {props.data.discount !='0' ? <tr className="">
            <th>&nbsp;</th>
            <th align="right">Discount&nbsp;Rs</th>
            <th align="center">{ Number(props.data.discount).toFixed(2)}</th>
          </tr> : <tr className="">
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>}
          {props.data.discount !='0'  ? <tr className="">
            <th>&nbsp;</th>
            <th align="right">Amount&nbsp;Rs</th>
            <th align="center">{ Number(props.data.amount).toFixed(2)}</th>
          </tr> : <tr className="">
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>}
            </table>
            <table width="100%" className="borderBottom borderLeft borderRight">
            <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>Billed By  : {props.data.user}</th>
            <th>Printed on : {props.data.date.split('-').reverse().join('-')}</th>
            <th>Authority&nbsp;Signature</th>
          </tr> 
            </table>
        </div>
        </div>
  );
};
export default Passprint;
